import { ErrorsState } from "./type";

export const getErrorObject = (state: ErrorsState) => state;



// WEBPACK FOOTER //
// ./src/store/Errors/selectors.ts